export default class ProviderUploadDocumentsService {
  constructor($uibModal) {
    'ngInject';

    this.$createInsuranceAppModal = $uibModal;
  }

  onUploadFiles(params) {
    return this.$createInsuranceAppModal.open(this.modalOption(params));
  }

  modalTemplate() {
    this.componentTemplate = `<provider-upload-documents
                                modal-instance="vm.modalInstance"
                                modal-data="vm.props.params">
                              </provider-upload-documents>`;
    return this.componentTemplate;
  }

  modalPropertyData(param = {}) {
    const params = {
      title: 'Create New Insurance Application',
      buttonLabel: 'Next Step',
      searchPlaceHolder: 'Search Client Name',
      ...param,
    };
    this.props = { params };
    return this.props;
  }

  modalOption(params) {
    this.modalOptions = {
      animation: true,
      template: this.modalTemplate(),
      controller: 'CommonModalPlaceholderCtrl',
      controllerAs: 'vm',
      backdrop: 'static',
      keyboard: false,
      size: 'lg',
      resolve: {
        props: () => this.modalPropertyData(params),
      },
    };
    return this.modalOptions;
  }
}
